import dojoTheme from './dojo-theme';

export function buildTheme(partnerTheme: any, variants: Record<string, any>) {
	return {
		theme: Object.assign({}, dojoTheme.theme, partnerTheme),
		variants: { ...dojoTheme.variants, ...variants }
	};
}
